import { Component, HostListener, OnInit } from '@angular/core';
import { FirebaseMessagingService } from 'src/app/shared/services/firebase-messaging.service';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import * as uuid from 'uuid';
import { NavigationEnd, Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { filter } from 'rxjs/operators';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  public title = 'Tata-Starbucks';
  public message: any = '';
  public idleState = 'Not started.';
  public timedOut = false;
  public previousUrl: string = '';
  constructor(
    private idle: Idle,
    private router: Router,
    private messagingService: FirebaseMessagingService
  ) {
    idle.setIdle(30);
    idle.setTimeout(5400);
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
    idle.onIdleEnd.subscribe(() => {
      this.idleState = 'No longer idle.'
    });
    idle.onTimeout.subscribe(() => {
      if (localStorage.excludeFromTimeout) {
        this.reset();
        return;
      }
      this.idleState = 'Timed out!';
      this.timedOut = true;
      let url = this.router.url
      if (url === '/ordering') {
        window.location.reload();
      } else {
        this.router.navigate(['/ordering']);
      }
    });
    idle.onIdleStart.subscribe(() => {
      this.idleState = 'You\'ve gone idle!'
    });
    idle.onTimeoutWarning.subscribe((countdown) => {
      this.idleState = 'You will time out in ' + countdown + ' seconds!'
    });
    this.reset();
    this.loadScripts();
    this.setPreviousPage();
  }
  ngOnInit(): void {
    this.initiateApplicationProcess();
  }
  totaldata() {
    var allStrings = '';
    for (var key in window.localStorage) {
      if (window.localStorage.hasOwnProperty(key)) {
        allStrings += window.localStorage[key];
      }
    }
    return allStrings ? 3 + ((allStrings.length * 16) / (8 * 1024)) + ' KB' : 'Empty (0 KB)';
  }
  public reset() {
    this.idle.stop();
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }
  public initiateApplicationProcess() {
    this.messagingService.requestPermission()
    this.messagingService.receiveMessage()
    this.message = this.messagingService.currentMessage;
    const getDeviceId = localStorage.getItem('deviceId');
    if (getDeviceId == null) {
      localStorage.setItem('deviceId', uuid.v4());
    }
  }
  public setGA() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
    })
  }
  /**
  * Method to append js in body
  */
  public loadScripts() {
    const dynamicScripts = [
      './assets/js/sbxui.js'
    ];
    for (let i = 0; i < dynamicScripts.length; i++) {
      const node = document.createElement('script');
      node.src = dynamicScripts[i];
      node.type = 'text/javascript';
      node.async = false;
      document.getElementsByTagName('body')[0].appendChild(node);
    }
  }
  /**
  * Method to set previous page
  */
  public setPreviousPage() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.previousUrl = event.url;
        sessionStorage.setItem('previousPage', this.previousUrl);
      });
  }
  /**
   * Method to set the design based on orinatation mode
   */
  @HostListener('window:orientationchange', ['$event'])
  onOrientationChange(event) {
    location.reload();
  }
}
